import React, { useEffect, useState } from 'react';
import './Projects.css';
import { Tabs } from 'antd';
import { renderProjectsByType } from '../../components/Project.js';
import { useLocation } from 'react-router-dom';
import { Project_Types_Categpories } from '../../utils/constants';

const Projects = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('Architecture');
    const [activeSubTab, setActiveSubTab] = useState(null);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const type = searchParams.get('type');
        if (type) {
            setActiveTab(type);
        }
        setActiveSubTab(null);
    }, [location.search]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        setActiveSubTab(null);
    };

    const handleSubTabChange = (subType) => {
        setActiveSubTab(subType);
    };

    const mainTabItems = Object.keys(Project_Types_Categpories).map((type) => ({
        key: type,
        label: type,
        children: (
            Project_Types_Categpories[type] && Project_Types_Categpories[type].length > 0 ? (
                <Tabs
                    activeKey={activeSubTab || "all"}
                    onChange={handleSubTabChange}
                    tabBarStyle={{ marginBottom: '20px' }}
                    items={[
                        {
                            key: "all",
                            label: "All",
                            children: renderProjectsByType(type),
                        },
                        ...Project_Types_Categpories[type].map((subType) => ({
                            key: subType,
                            label: subType,
                            children: renderProjectsByType(type, subType),
                        }))
                    ]}
                />
            ) : null
        ),
    }));

    return (
        <div className='blog-page'>
            <header className='height-75'>
                <div className='container h-100 min-vh-100 d-flex flex-column align-items-center justify-content-center text-light'>
                    <h1 className='text-center fw-semibold lspacing-10'>PROJECTS</h1>
                    <h3 className='text-center w-100 mb-5 lspacing-10'>Become Part of Our Next Success Chapter</h3>
                </div>
            </header>
            <div className='bg-body-tertiary py-5'>
                <div className="container">
                    <Tabs activeKey={activeTab} onChange={handleTabChange} items={mainTabItems} />
                </div>
            </div>
        </div>
    );
};

export default Projects;
